<template>
  <div class="w-100">
    <div class="empty-state">
      <div class="empty-state-icon">
        <v-icon size="22" color="primary">mdi-account-plus-outline</v-icon>
      </div>
      <p class="text-muted text-body-2">{{ message }}</p>
    </div>
    <div class="px-4 pb-4">
      <AppButtonFlat
        block
        prepend-icon="mdi-account-plus"
        :loading="isLoadingProviders"
        :disabled="isLoadingProviders"
        @click="handleAssignProfessional()"
      >
        {{ buttonText }}
      </AppButtonFlat>
    </div>
  </div>
</template>

<script setup lang="ts">
import AppButtonFlat from "@/shared/components/ui/AppButtonFlat.vue";
import { useModalStore } from "@/shared/stores/modal";
import AssignProfessionalModal from "@/modules/vendor/components/appointments/AssignProfessionalModal.vue";
import { ref } from "vue";

import { fetchServiceProviders } from "@/modules/vendor/services/vendors.api";

const props = withDefaults(
  defineProps<{
    appointment: Record<string, any>;
    message?: string;
    buttonText?: string;
  }>(),
  {
    message: "No professional assigned",
    buttonText: "Assign Now",
  }
);

const emit = defineEmits<{
  (e: "assigned"): void;
}>();

const modal = useModalStore();
const isLoadingProviders = ref(false);

async function handleAssignProfessional() {
  const vendorId = props.appointment.vendor_id;
  isLoadingProviders.value = true;

  try {
    const providersResponse = vendorId ? await fetchServiceProviders(vendorId) : [];
    console.log("providersResponse", providersResponse);
    const providers = Array.isArray(providersResponse)
      ? providersResponse
      : Array.isArray((providersResponse as any)?.data)
      ? (providersResponse as any).data
      : [];

    modal.open(
      AssignProfessionalModal,
      {
        appointment: props.appointment,
        providers,
        onAssigned: (appointment: Record<string, any>, provider: any | null) => {
          emit("assigned");
        },
      },
      {
        fullscreen: true,
        showHeader: false,
        title: "Assign Professional",
        scrollable: true,
      }
    );
  } finally {
    isLoadingProviders.value = false;
  }
}
</script>

<style scoped>
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  margin: 12px 0;
  text-align: center;
}

.empty-state-icon {
  width: 44px;
  height: 44px;
  border-radius: 14px;
  display: grid;
  place-items: center;
  background: rgba(25, 118, 210, 0.08);
}
</style>
